// extracted by mini-css-extract-plugin
export var error = "index-module--error--3zOBa";